import { render, staticRenderFns } from "./LevelBonusList.vue?vue&type=template&id=6a254aa2&"
import script from "./LevelBonusList.vue?vue&type=script&lang=js&"
export * from "./LevelBonusList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports